import React from 'react';

function formatAge(date) {
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) return `${minutes}m ago`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}

export default function OfflineIndicator({ lastUpdated }) {
  const msg = lastUpdated
    ? `Offline — showing data from ${formatAge(lastUpdated)}`
    : 'Offline — no cached data available';
  return (
    <div className="offline-banner">{msg}</div>
  );
}
